module.exports = __webpack_public_path__ + "img/qualiopi.90597a10.jpg";